// src/components/NaverMap.js
import React, { useEffect, useRef } from 'react';

function NaverMap() {
    const mapRef = useRef(null);
    const lat = 35.232873
    const lng = 126.889539
    
    useEffect(() => {
      const { naver } = window;
      if (mapRef.current && naver) {
        const location = new naver.maps.LatLng(lat, lng);
        const map = new naver.maps.Map(mapRef.current, {
          center: location,
          zoom: 17, // 지도 확대 정도
        });
        new naver.maps.Marker({
          position: location,
          map,
          title: '세연이앤에스',
        });
      }
    }, []);

  return (
    <div
      ref={mapRef}
      style={{
        width: '100%',
        height: '100%',
        border: '1px solid #e5e7eb',
      }}
    ></div>
  );
}


export default NaverMap;
